import { useGetGlobalSearchResultsPresenter } from './useGetGlobalSearchResultsPresenter'
import { GlobalSearchModal } from '../../views/GlobalSearchModal/GlobalSearchModal'

interface IGetGlobalSearchResultsPresenterProps {
  isOpen: boolean
  onClose: () => void
}

export const GetGlobalSearchResultsPresenter = ({
  isOpen,
  onClose,
}: IGetGlobalSearchResultsPresenterProps) => {
  const { query, showEnterHint, inputRef, onQueryChange, onSubmit } =
    useGetGlobalSearchResultsPresenter()

  return (
    <GlobalSearchModal
      isOpen={isOpen}
      query={query}
      showEnterHint={showEnterHint}
      recentItems={[]}
      inputRef={inputRef}
      onClose={onClose}
      onQueryChange={onQueryChange}
      onSubmit={onSubmit}
      onRecentItemClick={() => undefined}
    />
  )
}
